export const rethinkContactPath = (instanceUrl, contactId) => `${instanceUrl}/lightning/r/Contact/${contactId}/view`;
export const rethinkListPath = (instanceUrl, listId) => `${instanceUrl}/lightning/r/TTL_Core__List__c/${listId}/view`;
